var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3337C5.39752 18.3337 1.66669 14.6028 1.66669 10.0003C1.66669 5.39783 5.39752 1.66699 10 1.66699C14.6025 1.66699 18.3334 5.39783 18.3334 10.0003C18.3334 14.6028 14.6025 18.3337 10 18.3337ZM10 16.667C11.7681 16.667 13.4638 15.9646 14.7141 14.7144C15.9643 13.4641 16.6667 11.7684 16.6667 10.0003C16.6667 8.23222 15.9643 6.53652 14.7141 5.28628C13.4638 4.03604 11.7681 3.33366 10 3.33366C8.23191 3.33366 6.53622 4.03604 5.28598 5.28628C4.03573 6.53652 3.33335 8.23222 3.33335 10.0003C3.33335 11.7684 4.03573 13.4641 5.28598 14.7144C6.53622 15.9646 8.23191 16.667 10 16.667ZM9.16919 13.3337L5.63335 9.79783L6.81169 8.61949L9.16919 10.977L13.8825 6.26283L15.0617 7.44116L9.16919 13.3337Z",
    fill: "#1AA04B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.953c34ef662e4746946fc65b23238625.svg";
export { ForwardRef as ReactComponent };